exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Balances_emptyMessage_bPd_ {\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"emptyMessage": "Balances_emptyMessage_bPd_"
};